import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RequestBuilderService } from '@klickdata/core/http/src/request/request-builder.service';
import { ConfigService } from '@klickdata/core/config/src/config.service';
import { AuthService } from '@klickdata/core/auth/src/token/auth.service';
import { HttpErrorService } from '@klickdata/core/http/src/error/http-error.service';
import { LoginData } from '@klickdata/core/auth/src/auth/login.model';

@Injectable()
export class PasswordService {
    protected resourceUrl: string;

    constructor(
        protected builder: RequestBuilderService,
        protected config: ConfigService,
        protected auth: AuthService,
        protected error: HttpErrorService
    ) {
        this.resourceUrl = `${this.config.config.apiUrl}auth/password`;
    }

    public sendResetEmail(passwdData: LoginData): Observable<any> {
        return this.builder
            .post(`${this.resourceUrl}/email`, passwdData)
            .request()
            .pipe(
                map(res => res.data),
                catchError(err => this.error.handle(err))
            );
    }

    /**
     * Verify the reset token with backend before use.
     * This is not implemented!
     */
    public verifyResetToken(token: string): Observable<any> {
        return this.builder
            .post(`${this.resourceUrl}/verify`, { token })
            .request()
            .pipe(
                map(res => res.data),
                catchError(err => this.error.handle(err))
            );
    }

    public resetPassword(passwordReset: LoginData): Observable<any> {
        return this.builder
            .post(`${this.resourceUrl}/reset`, passwordReset)
            .request()
            .pipe(
                map(res => res.data),
                catchError(err => this.error.handle(err))
            );
    }

    public updatePassword(passwordReset: LoginData): Observable<any> {
        return this.builder
            .put(`${this.resourceUrl}/update`, passwordReset)
            .request()
            .pipe(map(res => this.auth.handleLogin(res)));
    }
}
